import { Button } from '../../ui/button';
import { ArrowDown } from 'lucide-react';

interface ScrollToBottomProps {
	scrollToBottomNewMessage: boolean;
	scrollToBottomTrigger: () => void;
}
export function ScrollToBottom(scrollToBottomProps: ScrollToBottomProps) {
	const { scrollToBottomNewMessage, scrollToBottomTrigger } = scrollToBottomProps;
	return (
		<>
			{scrollToBottomNewMessage ? (
				<Button
					className="absolute bottom-3 left-1/2 z-20 -translate-x-1/2 rounded-full whitespace-nowrap shadow-lg"
					variant="secondary"
					onClick={scrollToBottomTrigger}
				>
					<ArrowDown className="size-4" />
					New messages
				</Button>
			) : (
				''
			)}
		</>
	);
}
